import { IDeserialize } from "../models/abstraction/IDeserialize";

/** Checks if the given type implements interface `IDeserialize`.
 * Returns `true`, if it does. Otherwise false.
 */
export function isIDeserializable<T>(instance: object): instance is IDeserialize<T> {
  return instance && "deserialize" in instance;
}
